module.exports = __webpack_public_path__ + "static/media/video_consent_audio_kannada.7e4e56a3.mp3";